import { createSelector } from 'reselect';

const selectDbnAgents = (state: any) => state.dbnAgents;


export const selectDbnAgentsCurrentItem = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.current);

export const selectDbnAgentsListItems = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDbnAgentsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbnAgentsQueryItems = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.query);

export const selectDbnAgentsCreatedItem = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.create);

export const selectDbnAgentsUpdatedItem = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.update);

export const selectDbnAgentsReadItem = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.read);

export const selectDbnAgentsDeletedItem = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.delete);

export const selectDbnAgentsSearchedItems = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.search);

export const selectDbnAgentsItemsCount = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.count);

export const selectDbnAgentsItemsFilter = createSelector([selectDbnAgents], (dbnAgents) => dbnAgents.filter);